// Pure tab configuration + visibility resolver for the Digital Twin "Alerts" tab.
// Kept free of React/MUI imports so it can be unit-tested without pulling in the
// component dependency tree.

export const ALL_TABS = [
    { slug: 'bms-faults', name: 'Battery System Faults', feature: 'DigitalTwin.Alerts.BmsFaults' },
    { slug: 'platform-alerts', name: 'Smart Alerts', feature: 'DigitalTwin.Alerts.PlatformAlerts' },
];

/**
 * Resolve which alert sub-tabs are visible. A tab needs its org-level feature
 * flag in enabledFeatures; each tab is additionally gated on its RBAC view
 * permission so users without it do not see the tab at all:
 *   - Battery System Faults -> BMS_FAULTS_V2 view (canViewBmsFaults)
 *   - Platform Alerts       -> PLATFORM_ALERTS_V2 view (canViewPlatformAlerts),
 *                              hiding even the legacy Alert and Warning Log.
 */
export function getAvailableAlertTabs(enabledFeatures = [], { canViewPlatformAlerts = false, canViewBmsFaults = false } = {}) {
    return ALL_TABS.filter(tab => {
        if (!enabledFeatures.includes(tab.feature)) return false;
        if (tab.slug === 'platform-alerts') return canViewPlatformAlerts;
        if (tab.slug === 'bms-faults') return canViewBmsFaults;
        return true;
    });
}
